import { render } from "./DiferenciaValores.vue?vue&type=template&id=078c1630&scoped=true"
import script from "./DiferenciaValores.vue?vue&type=script&lang=js"
export * from "./DiferenciaValores.vue?vue&type=script&lang=js"

import "./DiferenciaValores.vue?vue&type=style&index=0&id=078c1630&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078c1630"]])

export default __exports__